import equal from 'lodash.isequal'


class Element {
  constructor(type, children, data) {
    this.type = type
    this.children = children
    this.data = data || {}
  }

  isEqual(element) {
    return element instanceof Element
      && this.type === element.type
      && equal(this.data, element.data)
      && this.children.length === element.children.length
      && this.children.every((c, i) => c.isEqual(element.children[i]))
  }
}

export default Element